export class TimeoutError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'TimeoutError';
    }
}

export async function withTimeout<T>(millis: number, promise: Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        const timeoutHandler = window.setTimeout(() => {
            reject(new TimeoutError(`Operation timed out after ${millis}ms`));
        }, millis);

        promise
            .then(result => {
                window.clearTimeout(timeoutHandler);
                resolve(result);
            })
            .catch(error => {
                window.clearTimeout(timeoutHandler);
                reject(error);
            });
    });
}